import React from "react";
import { SiPython } from "react-icons/si";

const PyCliDeployments = () => {
  return (
    <div className="doc_page_cont">
      <p className="doc_page_cont_title">
        <SiPython /> Deployments
      </p>

      <p className="doc_page_cont_paragraph">
        The <strong>Erioon CLI</strong> lets you deploy Python services and projects directly from your terminal.
        You can authenticate, initialize projects, and deploy services without writing extra Python code.
      </p>

      <SDKFunction
        id="cli-deployments"
        title="Erioon CLI Deployment Usage"
        description={
          <>
            <p>
              The CLI handles login, project initialization, and deployment of Python services or AI/ML models.
              Follow these steps to deploy your project:
            </p>

            <ol className="doc_list">
              <li>
                <strong>Install Erioon CLI:</strong> <code>pip install erioon</code>
              </li>
              <li>
                <strong>Login:</strong> <code>erioon login</code>. You can log in with an API key or access credentials.
              </li>
              <li>
                <strong>Initialize your project:</strong> <code>erioon init</code> inside your project folder.
              </li>
              <li>
                <strong>Select your project</strong> from the interactive list.
              </li>
              <li>
                <strong>Name your deployment</strong> and select the deployment type (e.g., service).
              </li>
              <li>
                <strong>Deploy your service:</strong> select your Python file, optionally set a schedule, and let the CLI handle deployment.
              </li>
            </ol>

            <p><strong>Notes:</strong></p>
            <ul className="doc_list">
              <li>Requirements: One <code>requirements.txt</code> file is required.</li>
              <li>Python files: Only one service file can be selected per deployment.</li>
              <li>Scheduled deployments are supported using cron-like syntax.</li>
            </ul>
          </>
        }
        code={`
# Install the CLI
pip install erioon

# Login (API key or credentials)
erioon login

# Initialize your project and deploy a service
cd my_project
erioon init

# Follow the interactive prompts:
# 1. Choose project
# 2. Enter deployment name
# 3. Choose deployment type
# 4. Select Python file to deploy
# 5. Optionally schedule deployment
`}
      />
    </div>
  );
};

// Reusable documentation block
const SDKFunction = ({ id, title, description, code }) => (
  <div className="sdk_section" id={id}>
    <p className="doc_page_cont_subtitle">{title}</p>
    <div className="doc_page_cont_paragraph">{description}</div>
    <pre className="code_block_docs">{code}</pre>
  </div>
);

export default PyCliDeployments;
